import requests from '@/utils/requests';

/**
 * apm数据查询
 * @param {*} data
 */
export function apmQuery(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/apmQuery',
    method: 'post',
    data
  });
}
